// Fire-and-forget client telemetry: posts per-operation timings to the
// Railway admin dashboard so msiblini can spot slow flight/airbnb/AI calls.
// Never throws, never blocks the caller, never logs noise to the console.
//
// Usage:
//   const t = startTimer();
//   try {
//     const result = await searchFlights(...);
//     reportTiming("flight", t.ms(), true, { origin: "LAX", dest: "PAR" });
//   } catch (e) {
//     reportTiming("flight", t.ms(), false, { origin: "LAX", dest: "PAR" }, e.message);
//   }
//
// Or inline:
//   const start = Date.now();
//   await doThing();
//   reportTiming("flight", Date.now() - start, true, { origin, dest });

import { getAuthHeader } from "./supabaseClient";

const ENDPOINT = "https://flybnb.up.railway.app/admin/api/log-timing";

export function startTimer() {
  const t0 = Date.now();
  return {
    ms: () => Date.now() - t0,
  };
}

// Fire-and-forget. Returns nothing useful. Never rejects.
export function reportTiming(type, ms, success, meta, error) {
  try {
    const body = {
      type,
      ms: Math.max(0, Math.round(ms)),
      success: !!success,
      meta: meta && typeof meta === "object" ? meta : null,
      error: typeof error === "string" ? error.slice(0, 200) : null,
    };
    // Build headers but don't block on getAuthHeader. If it resolves quickly,
    // great — we get user attribution. If it doesn't, we still send anon.
    Promise.resolve(getAuthHeader())
      .then((auth) =>
        fetch(ENDPOINT, {
          method: "POST",
          headers: { "Content-Type": "application/json", ...auth },
          body: JSON.stringify(body),
          keepalive: true, // survive page navigation
        })
      )
      .catch(() => {}); // swallow — telemetry must never break the app
  } catch {
    // even constructing the body shouldn't throw, but just in case
  }
}
